import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'bbsf-utilities';

@Component({
  selector: 'app-aside-menu',
  templateUrl: './aside-menu.component.html'
})
export class AsideMenuComponent implements OnInit {
  appAngularVersion: string = "";
  appPreviewChangelogUrl: string = "";

  constructor(private utilityService:UtilityService) {}

  ngOnInit(): void { }

  getResourceValue(Key) {
    return this.utilityService.getResourceValue(Key);
  }
}
